import {it, de, deAT, itCH, frCH} from 'date-fns/locale'

/**
 * This object is used to map our current sites locals to the correct Date-fns object
 * Any new site should be added here
 */

export const localeMap = {
    'it-it': it, // Italy (it-IT)
    'de-de': de, // Germany (de-DE)
    'de-at': deAT, // Austria (de-AT)
    'de-ch': itCH, // Switzerland (it-CH)
    'fr-ch': frCH, // Switzerland (fr-CH)
}
